import { useMemo } from 'react';

import useCredentialsExpiringSoonCount from 'src/common/credentials/useCredentialsExpiringSoonCount';
import type { NavItem } from 'src/common/NavBar/TopLevelNavItemContext';
import { TabNavigation } from 'src/common/TabNavigation';

const fleetTabs: NavItem[] = [
  { name: 'Vehicles', href: '/fleet' },
  { name: 'Inspections', href: '/fleet/inspections' },
  {
    name: 'Credentials',
    href: '/fleet/credentials',
    matcher: '/fleet/credentials/*',
  },
];

export function FleetNav() {
  const expiredCredentialsCount = useCredentialsExpiringSoonCount();

  const hydratedFleetTabs = useMemo(() => {
    return fleetTabs.map((tab) =>
      tab.href === '/fleet/credentials'
        ? { ...tab, badgeCount: expiredCredentialsCount?.vehicle }
        : tab
    );
  }, [expiredCredentialsCount]);

  return <TabNavigation tabs={hydratedFleetTabs} />;
}
